import { render, staticRenderFns } from "./CardTransaction.vue?vue&type=template&id=618190a8&scoped=true&"
import script from "./CardTransaction.vue?vue&type=script&lang=js&"
export * from "./CardTransaction.vue?vue&type=script&lang=js&"
import style0 from "./CardTransaction.vue?vue&type=style&index=0&id=618190a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618190a8",
  null
  
)

export default component.exports